import {Attachment, getTextByLang} from "./Game";
import {getLangFromUrl} from "./Header";

export const StandaloneGalleryItem = ({attachment}: { attachment: Attachment }) => {
    const lang = getLangFromUrl()

    if (!attachment) return null;
    const url = getTextByLang(attachment.file, lang);
    const isVid = /\.(mp4|webm|ogg|mov)$/i.test(url.split("?")[0]);
    const title = getTextByLang(attachment.name, lang);
    const desc = getTextByLang(attachment.description, lang);
    return (
        <div className="standalone-wrapper">
            <div className="standalone-section">
                {title && <h2 className="standalone-title">{title}</h2>}
                {desc && <p className="standalone-desc">{desc}</p>}
                <div className="standalone-media-wrap">
                    {isVid ? (
                        <video
                            src={url}
                            controls
                            className="standalone-media"
                        />
                    ) : (
                        <img
                            src={url}
                            alt={title}
                            className="standalone-media"
                        />
                    )}
                </div>
            </div>
        </div>
    );
}